import { createContext } from "react"
import { TextoModel } from "../models/textoModel"
import { TextoImpressaoActionModel } from "./textoImpressaoActions"
import { TextoImpressaoInicial } from "./textoImpressaoInicial"

type textoImpressaoContextProps = {
    textoImpressao: TextoModel
    dispatchTexoImpressao: React.Dispatch<TextoImpressaoActionModel>
    salvarConfiguracoes: () => Promise<void>
    carregando: boolean
    layouts: TextoModel[]
    layoutAtivoId: string | undefined
    selecionarLayout: (id: string) => void
    criarLayout: (nome: string) => Promise<void>
    duplicarLayout: () => Promise<void>
    renomearLayout: (novoNome: string) => Promise<void>
    excluirLayout: (id: string) => Promise<void>
}

const initialContextValue: textoImpressaoContextProps = {
    textoImpressao: TextoImpressaoInicial,
    dispatchTexoImpressao: () => {},
    salvarConfiguracoes: async () => {},
    carregando: false,
    layouts: [],
    layoutAtivoId: undefined,
    selecionarLayout: () => {},
    criarLayout: async () => {},
    duplicarLayout: async () => {},
    renomearLayout: async () => {},
    excluirLayout: async () => {},
}

export const TextoImpressaoContext = createContext<textoImpressaoContextProps>(initialContextValue)
